/**
 * Image utility functions
 */

/**
 * Preprocess image for better OCR accuracy
 * @param {string} imageData - Image data URL
 * @returns {string} Preprocessed image data URL
 */
export const preprocessImage = (imageData) => {
  // Tesseract.js handles most preprocessing internally
  // If needed, we can add custom preprocessing here using canvas
  return imageData;
};

/**
 * Clean name by removing extra spaces and special characters
 * @param {string} name - Name to clean
 * @returns {string} Cleaned name
 */
export const cleanName = (name) => {
  if (!name) return '';
  return name
    .replace(/\s+/g, ' ')  // Replace multiple spaces with single space
    .replace(/[^\w\s\u0980-\u09FF\u09E0-\u09EF\.]/g, '')  // Remove special characters except dots and Bangla
    .trim();
};

/**
 * Extract text until a label is found
 * @param {string} text - Text to search
 * @param {Array<RegExp>} labels - Array of label patterns to match
 * @returns {string} Extracted text
 */
export const extractUntilLabel = (text, labels) => {
  let result = text;
  let earliestMatch = null;
  let earliestIndex = Infinity;

  for (const label of labels) {
    const match = text.match(label);
    if (match) {
      const index = text.indexOf(match[0]);
      if (index < earliestIndex) {
        earliestIndex = index;
        earliestMatch = match;
      }
    }
  }

  if (earliestMatch) {
    result = text.substring(0, earliestIndex).trim();
  }

  return result;
};
